import { takeLatest, all, put, call, select, race, delay } from "redux-saga/effects";
import { authClient, oauthCallbackURL } from '../../lib/auth';

import { clearLocalDiagramStores } from '../../lib/yjs';

import { authActionTypes } from "./auth.types";
import {
	updateSessionStatus,

	signUpSuccess,
	signUpFailure,

	signInSuccess,
	signInFailure,

	signOutSuccess,
	signOutFailure,

	forgotPasswordSuccess,
	forgotPasswordFailure,

	resetPasswordSuccess,
	resetPasswordFailure,

	updateUserSuccess,
	updateUserFailure,

	deleteUserSuccess,
	deleteUserFailure,
} from "./auth.actions";

import { showNotify } from "../notify/notify.actions";

function checkError(error) {
	// Network / connection error (request didn't reach backend)
	if (!error || !error.code) {
		if (typeof navigator !== 'undefined' && navigator.onLine === false) {
			error.message = 'No internet connection. Please try again.';
		} else {
			error.message = "Something went wrong.";
			// error.message = `Can't connect. ${JSON.stringify(error)}`;
		}
	}
	return error;
}

export function* checkUserSession() {
	// null

	// {
	//     "session": {
	//         "id": "1IiajO70nIzxBzHMsmsnKbzfDtCntzZi",
	//         "expiresAt": "2025-03-07T15:11:34.000Z",
	//         "token": "nLPaweprFf6Hrtr3Znjz0wv07eC6ZhEL",
	//         "createdAt": "2025-03-04T15:11:34.000Z",
	//         "updatedAt": "2025-03-04T15:11:34.000Z",
	//         "ipAddress": "",
	//         "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/131.0.0.0 Safari/537.36",
	//         "userId": "Jme2dea2dASaeiQyCaLlU668YSRVaPoN"
	//     },
	//     "user": {
	//         "id": "Jme2dea2dASaeiQyCaLlU668YSRVaPoN",
	//         "name": "tt@tt.tt",
	//         "email": "tt@tt.tt",
	//         "emailVerified": 0,
	//         "image": null,
	//         "createdAt": "2025-03-04T01:02:20.000Z",
	//         "updatedAt": "2025-03-04T01:02:20.000Z"
	//     }
	// }

	try {
		const { data, error } = yield authClient.getSession();
		if (!data) {
			yield put(updateSessionStatus('not_authorized'));
		} else if (error) {
			const updError = checkError(error);
			yield put(signInFailure(updError));
		} else {
			yield put(signInSuccess({
				user: data.user,
				lastActiveWorkspaceId: data.user?.last_active_workspace_id ?? null,
			}));
		}
	} catch (e) {
		const updError = checkError(e);
		yield put(signInFailure(updError));
	}
}

export function* signUpEmail({ payload: { email, name, password } }) {
	try {
		// {
		// 	"token": "90CU7zZPdXaLwgTZViJTeqxqjwmB0dju",
		// 	"user": {
		// 		"id": "R9wGnegF40OfpxY1p42M05pVYvhlYhUw",
		// 		"email": "test.test@test.com",
		// 		"name": "test.test",
		// 		"image": null,
		// 		"emailVerified": 0,
		// 		"createdAt": "2025-02-28T06:17:54.000Z",
		// 		"updatedAt": "2025-02-28T06:17:54.000Z"
		// 	}
		// }

		// {
		// 	"message": "Failed to create user",
		// 	"details": {
		// 		"code": "ER_NO_DEFAULT_FOR_FIELD",
		// 		"errno": 1364,
		// 		"sqlState": "HY000",
		// 		"sqlMessage": "Field 'name' doesn't have a default value",
		// 		"sql": "insert into `user` (`id`, `email`, `emailVerified`, `createdAt`, `updatedAt`) values ('jRokwosRRlIg95B417jgNEPFGt0vbCvA', 'test.test@test.com', false, '2025-02-27 22:17:00.879', '2025-02-27 22:17:00.879')"
		// 	},
		// 	"code": "FAILED_TO_CREATE_USER",
		// 	"status": 422,
		// 	"statusText": "Unprocessable Entity"
		// }

		const { data, error } = yield authClient.signUp.email({ email, name, password });
		if (error) {
			const updError = checkError(error);
			yield put(signUpFailure(updError));
		} else {
			yield put(signUpSuccess({ user: data.user }));
		}
	} catch (e) {
		const updError = checkError(e);
		yield put(signUpFailure(updError));
	}
}

export function* signInEmail({ payload: { email, password } }) {
	// {
	// 	"redirect": false,
	// 	"token": "sxeoRRP2YeCSagZi6PbF0r9b8Bab5IDq",
	// 	"user": {
	// 		"id": "X6uIIYfOYqkTCZ2ua6xFXc3BGOhZ0pDD",
	// 		"email": "t@gmail.com",
	// 		"name": "t",
	// 		"image": null,
	// 		"emailVerified": 0,
	// 		"createdAt": "2025-02-28T07:00:59.000Z",
	// 		"updatedAt": "2025-02-28T07:00:59.000Z"
	// 	}
	// }

	// {
	// 	"message": "Invalid email or password",
	// 	"code": "INVALID_EMAIL_OR_PASSWORD",
	// 	"status": 401,
	// 	"statusText": "Unauthorized"
	// }

	try {
		const { data, error } = yield authClient.signIn.email({ email, password });
		if (error) {
			const updError = checkError(error);
			yield put(signInFailure(updError));
		} else {
			const user = data.user;
			yield put(signInSuccess({
				user,
				lastActiveWorkspaceId: user?.last_active_workspace_id ?? null,
			}));
		}
	} catch (e) {
		const updError = checkError(e);
		yield put(signInFailure(updError));
	}
}

export function* signInWithGoogle() {
	try {
		const { data, error } = yield authClient.signIn.social({ provider: "google", callbackURL: oauthCallbackURL() });
		if (error) {
			const updError = checkError(error);
			yield put(signInFailure(updError));
		}
	} catch (e) {
		const updError = checkError(e);
		yield put(signUpFailure(updError));
	}
}

export function* signInWithGithub() {
	try {
		const { data, error } = yield authClient.signIn.social({ provider: "github", callbackURL: oauthCallbackURL() });
		if (error) {
			const updError = checkError(error);
			yield put(signInFailure(updError));
		}
		// yield put(signUpSuccess({ user: data?.user }));
	} catch (e) {
		yield put(signUpFailure(e));
	}
}

export function* signInWithMicrosoft() {
	try {
		const { data, error } = yield authClient.signIn.social({ provider: "microsoft", callbackURL: oauthCallbackURL() });
		if (error) {
			const updError = checkError(error);
			yield put(signInFailure(updError));
		}
	} catch (e) {
		yield put(signUpFailure(e));
	}
}


export function* signOut() {
	try {
		// Capture userId BEFORE the auth reducer clears it on signOutSuccess —
		// we need it to scope the IndexedDB cleanup to this user's diagram caches.
		const userId = yield select((state) => state.auth?.currentUser?.id);

		const { error } = yield authClient.signOut({
			// fetchOptions: { onSuccess: () => window.location.href = "/login" }
		});

		if (error) {
			yield put(signOutFailure(error));
		} else {
			// Best-effort cleanup of locally-cached diagrams. Never blocks sign-out.
			yield call(clearLocalDiagramStores, userId);
			yield put(signOutSuccess());
		}
	} catch (e) {
		yield put(signOutFailure(e.message));
	}
}


export function* forgotPassword({ payload: { email, redirectTo } }) {
	try {
		// better-auth ≥1.4 renamed authClient.forgetPassword → requestPasswordReset (same args).
		const { error } = yield authClient.requestPasswordReset({ email, redirectTo });

		if (error) {
			yield put(forgotPasswordFailure(error));
		} else {
			yield put(forgotPasswordSuccess());
		}
	} catch (e) {
		yield put(forgotPasswordFailure(e));
	}
}

export function* resetPassword({ payload: { newPassword, token } }) {
	try {
		const { status, error } = yield authClient.resetPassword({ newPassword, token });
		if (error) {
			yield put(resetPasswordFailure(error));
		} else {
			yield put(resetPasswordSuccess());
		}
	} catch (e) {
		yield put(resetPasswordFailure(e));
	}
}

export function* updateUser({ payload }) {
	try {
		const { data, error } = yield authClient.updateUser(payload);
		if (error) {
			yield put(updateUserFailure(error));
			// yield put(showNotify({ message: error.message || 'Failed to update profile.' }));
			yield put(showNotify({ message: 'profile_update_failed' }));
		} else {
			yield put(updateUserSuccess(payload));
			yield put(showNotify({ message: 'profile_updated' }));
		}
	} catch (e) {
		yield put(updateUserFailure(e));
		yield put(showNotify({ message: 'something_wrong' }));
	}
}

export function* deleteUser() {
	try {
		const { error } = yield authClient.deleteUser();
		if (error) {
			yield put(deleteUserFailure(error));
			yield put(showNotify({ message: 'account_delete_failed' }));
		} else {
			yield put(deleteUserSuccess());
		}
	} catch (e) {
		yield put(deleteUserFailure(e));
		yield put(showNotify({ message: 'something_wrong' }));
	}
}

// SESSION
export function* onCheckUserSession() {
	yield takeLatest(authActionTypes.CHECK_USER_SESSION, checkUserSession);
}

// SIGN UP: EMAIL
export function* onSignUpEmail() {
	yield takeLatest(authActionTypes.SIGN_UP_EMAIL_START, signUpEmail);
}

// SIGN IN: EMAIL
export function* onSignInEmail() {
	yield takeLatest(authActionTypes.SIGN_IN_EMAIL_START, signInEmail);
}

// SIGN IN: GOOGLE
export function* onSignInGoogleStart() {
	yield takeLatest(authActionTypes.SIGN_IN_GOOGLE_START, signInWithGoogle);
}

// SIGN IN: GITHUB
export function* onSignInGithubStart() {
	yield takeLatest(authActionTypes.SIGN_IN_GITHUB_START, signInWithGithub);
}

// SIGN IN: MICROSOFT
export function* onSignInMicrosoftStart() {
	yield takeLatest(authActionTypes.SIGN_IN_MICROSOFT_START, signInWithMicrosoft);
}

// SIGN OUT
export function* onSignOutStart() {
	yield takeLatest(authActionTypes.SIGN_OUT_START, signOut);
}

// FORGOT PASSWORD
export function* onForgotPassword() {
	yield takeLatest(authActionTypes.FORGOT_PASSWORD_START, forgotPassword);
}

// RESET PASSWORD
export function* onResetPassword() {
	yield takeLatest(authActionTypes.RESET_PASSWORD_START, resetPassword);
}

// UPDATE USER
export function* onUpdateUser() {
	yield takeLatest(authActionTypes.UPDATE_USER_START, updateUser);
}

// DELETE USER
export function* onDeleteUser() {
	yield takeLatest(authActionTypes.DELETE_USER_START, deleteUser);
}

export function* authSagas() {
	yield all
		([
			call(onCheckUserSession),
			call(onSignUpEmail),
			call(onSignInEmail),
			call(onSignInGoogleStart),
			call(onSignInGithubStart),
			call(onSignInMicrosoftStart),
			call(onSignOutStart),
			call(onForgotPassword),
			call(onResetPassword),
			call(onUpdateUser),
			call(onDeleteUser),
		]);
}